module.exports = __webpack_public_path__ + "static/media/packingseal.a422e1cc.png";